import React, { createContext, useContext, useState } from 'react';
import { getWebsiteTexts } from '../sanity/client';

const SanityTextsContext = createContext();

export const useSanityTexts = () => {
  const context = useContext(SanityTextsContext);
  if (!context) {
    throw new Error('useSanityTexts must be used within SanityTextsProvider');
  }
  return context;
};

export const SanityTextsProvider = ({ children }) => {
  // Cache is session-based - clears on page refresh
  const [textsCache, setTextsCache] = useState({});
  const [loadingStates, setLoadingStates] = useState({});

  const fetchTexts = async (category) => {
    // Return cached data immediately if available
    if (textsCache[category]) {
      return textsCache[category];
    }

    // If already loading, wait for it
    if (loadingStates[category]) {
      return loadingStates[category];
    }

    // Create promise and cache it
    const promise = getWebsiteTexts(category)
      .then(data => {
        setTextsCache(prev => ({ ...prev, [category]: data }));
        setLoadingStates(prev => {
          const newState = { ...prev };
          delete newState[category];
          return newState;
        });
        return data;
      })
      .catch(error => {
        console.error(`Error fetching texts for ${category}:`, error);
        setLoadingStates(prev => {
          const newState = { ...prev };
          delete newState[category];
          return newState;
        });
        return [];
      });

    setLoadingStates(prev => ({ ...prev, [category]: promise }));
    return promise;
  };

  const value = {
    fetchTexts,
    textsCache
  };

  return (
    <SanityTextsContext.Provider value={value}>
      {children}
    </SanityTextsContext.Provider>
  );
};
